const forms = () => {
  /*
   * SELECTORS
   */
  const els = {
    $form: $('form'),
    $formInputComponent: $('.form-row,.form-row p'),
    $formInput: $('.form-row input, .client-form-row input'),
    $policy: $('#policy'),
    $labelAcc: $('label.accept'),
    $submitFormBTN: $('.submit-row .btn'),
    $positionFormBtn: $('.single-position-form .wpcf7-submit'),
    $simpleFormSubmitBtn: $(
      '.policy-form .wpcf7-submit,.block-contact-form .wpcf7-submit'
    ),
    $newsletterBTN: $('.newsletter .btn-newsletter'),
    $newsletterSubmit: $('.newsletter .form-submit input'),
    $selectedPosition: $(' #selected-position'),
    $selectedPositionName: $('.single-position-hero .text-content h1'),
    $selectedPositionURL: $(' #selected-position-url'),
  };
  const {
    $form,
    $formInput,
    $policy,
    $labelAcc,
    $submitFormBTN,
    $positionFormBtn,
    $newsletterBTN,
    $newsletterSubmit,
    $simpleFormSubmitBtn,
    $selectedPosition,
    $selectedPositionName,
    $selectedPositionURL,
    $formInputComponent,
  } = els;


  // input effect
  if ($form.length) {
    /*
     * EVENTS
     */

    let inputPosition = document.querySelector('#selected-position');
    if (inputPosition !== null) {
      let positionText = document.querySelector('h1').innerHTML;
      let inputPositionUrlLink = window.location.href;
      let inputPositionUrl = document.querySelector('#selected-position-url');
      inputPosition.value = positionText;
      inputPosition.setAttribute('value', positionText)
      inputPositionUrl.value = inputPositionUrlLink;
      inputPositionUrl.setAttribute('value', inputPositionUrlLink)
    }
    const validateFormInputs = function () {
      $(this).parent().parent().removeClass('active');
      if (!$(this).val()) {
        $(this).parent().parent().removeClass('active');
      }
      $(this).on('focus', function () {
          $(this).parent().parent().addClass('active no-error');
          $(this).next().hide();

        })
        .blur(function () {
          if ($(this).val().length < 1) {
            $(this).parent().parent().removeClass('active');
          }
        });
      if ($(this).val().length > 0) {
        $(this).parent().parent().addClass('active');
        $(this).next().hide();
      } else if (!$(this).attr('data-placeholder') === '') {
        $(this).parent().parent().addClass('active');
        $(this).next().hide();
      } else if (!$(this).attr('autocomplete') === '') {
        $(this).parent().parent().addClass('active');
        $(this).next().hide();
      } else if($(this).is(':-webkit-autofill')){
        $(this).parent().parent().addClass('active');
        $(this).next().hide();
      }else {
        $(this).parent().parent().removeClass('active');
      }
    };
    const policyValidation = function () {
      if ($(this).is(':checked')) {
        $formInputComponent.removeClass('no-error');
        $labelAcc.addClass('checked');
        $labelAcc.removeClass('red');
        $submitFormBTN.removeClass('disabled');
      } else {
        $labelAcc.removeClass('checked');
        $submitFormBTN.addClass('disabled');
      }
    };
    const fileUploader = document.querySelectorAll('.wpcf7-file');
    fileUploader.forEach(function (el){
      el.addEventListener('change', (event) => {
        let parent = event.target.parentNode.parentNode.parentNode;
        if(!event.target.files.length) {
          parent.classList.remove('filled');
        } else {
          parent.classList.add('filled');
        }
      });
    });

    const positionFormDisableBtnValidation = function () {
      if ($policy.is(':checked') && $positionFormBtn.parents('form').find('#resume').length) {
        $labelAcc.removeClass('red');
        $positionFormBtn.trigger('click');
      } else {
        $labelAcc.addClass('red');
      }
    };
    const simpleFormSubmit = function () {
      $simpleFormSubmitBtn && $simpleFormSubmitBtn.trigger('click');
      $('.wpcf7-submit').prop('disabled', true);
    };

    $('.file-row input').on('click', function () {
      $(this).parent().parent().next() &&
        $(this).parent().parent().next().hide();
    });
    /*
     * ACTIONS
     */
    $formInput.each(validateFormInputs);
    $selectedPosition.val($selectedPositionName.text());
    $selectedPositionURL.val(window.location.href);
    $policy.on('click', policyValidation);
    $submitFormBTN.on('click', positionFormDisableBtnValidation);
    $submitFormBTN.on('click', simpleFormSubmit);
    $(document).on('wpcf7invalid ', () => {
      $('.wpcf7-submit').prop('disabled', false);
    });
    $(document).on('wpcf7mailsent', () => {
      $('.file-row .wpcf7-not-valid-tip').remove();
      $('.wpcf7-submit').prop('disabled', true);
      setTimeout(() => {
        location.reload();
      }, 3000)
    });
    $newsletterBTN.on('click', () => $newsletterSubmit.trigger('click'));
  }
};

export default forms;



// WEBPACK FOOTER //
// ./scripts/components/form.js